import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'

export class GetSuggestAIApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'product/productSuggestAI/',
      requesterInfo,
    })
  }

  public async getSuggest(request: number): Promise<any> {
    this.props.url = this.props.url + request
    return await this.postAsync<any>(request)
  }
}
